export default __webpack_public_path__ + "static/media/AtomsAndCompounds _14.1e726404.png";